/** @format */

import { MenuItem, TextField, Select } from "@mui/material";
import React, { useEffect, useState } from "react";
// import {LoadingButton} from "@mui/lab";
// import IconButton from "@mui/material/IconButton";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { Row } from "react-bootstrap";
import Col from "react-bootstrap/cjs/Col";

// import { FaAngleDown } from "react-icons/fa";
// import Stack from "@mui/material/Stack";

import DialogContentText from "@mui/material/DialogContentText";
// import { components } from "react-select";
import Waba from "../../dao/Waba";
import swal from "../../reusables/CustomSwal";
// import { useNavigate } from "react-router-dom";

// const TABLE_HEAD = [
//   { id: "count", label: "No.", alignRight: false, sortable: false },
//   { id: "waba_id", label: "WABA ID", alignRight: false, sortable: true },
//   // {id: 'role', label: 'Role', alignRight: false, sortable: true},
// ];

// const DropdownIndicator = (props) => {
//   return (
//     components.DropdownIndicator && (
//       <components.DropdownIndicator {...props}>
//         <FaAngleDown color={"grey"} />
//       </components.DropdownIndicator>
//     )
//   );
// };

const industryOptions = [
  "Information Technology",
  "Marketing",
  "Food and Beverage",
];

export default function UpdateWabaDialog(props) {
  //   const navigate = useNavigate();
  const { open, onClose } = props;
  const { details } = props;
  const [wabaId, setWabaId] = useState(null);
  const [wabaName, setWabaName] = useState(null);
  const [wabaDesc, setWabaDesc] = useState(null);
  const [wabaIndustry, setWabaIndustry] = useState(null);
  const [wabaWebsite, setWabaWebsite] = useState(null);
  // const [wabas, setWabas] = useState([])

  const reset = () => {
    setWabaId(null);
  };

  // const getWabaId = async () => {
  //     try {
  //         let result = await Waba.getWabaId(selectedWabaId);
  //         setWabas(result);
  //     } catch (e) {
  //         console.log(e)
  //     }
  // }
  //
  // useEffect(()=>{
  //     getWabaId()
  // },[])

  useEffect(() => {
    setWabaId(details.waba_id);
    setWabaDesc(details.description);
    setWabaIndustry(details.industry);
    setWabaName(details.name);
    setWabaWebsite(details.website);
  }, [details]);

  const onSubmit = async (id) => {
    try {
      const body = {
        name: wabaName,
        industry: wabaIndustry,
        description: wabaDesc,
        website: wabaWebsite,
      };

      // console.log("TES", body);

      swal
        .fire({
          title: "",
          text: "Are you sure you want to update this item?",
          icon: "warning",
          showCancelButton: true,
          confirmButton: "Yes",
          confirmButtonColor: "#3085d6",
          cancelButton: "Cancel",
          // cancelButtonColor: '#d33',
        })
        .then(async (result) => {
          try {
            if (result.isConfirmed) {
              let res = await Waba.updateWaba(body, id);
              if (res.id || res.success) {
                await swal.fire({
                  title: "",
                  text: "Update Successful",
                  icon: "success",
                });
              }
              handleClose(true);
            } else {
              await swal.fire({
                title: "",
                text: "Update Failed",
                icon: "error",
              });
            }
          } catch (e) {
            console.error(e);
            await swal.fire({
              title: "",
              text: e.error_message ? e.error_message : "Something Wrong",
              icon: "error",
            });
          }
        });
    } catch (e) {
      console.log(e);
    }
  };

  const handleClose = (refresh) => {
    reset();
    onClose(refresh);
  };

  return (
    <>
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={open}
        onClose={() => onClose()}
      >
        <DialogTitle>Edit WABA</DialogTitle>
        <DialogContent>
          <DialogContentText>WABA ID</DialogContentText>
          <Row>
            <Col md={12}>
              <TextField
                fullWidth
                onChange={(e) => {
                  setWabaId(e.target.value);
                }}
                disabled
                placeholder={"Insert WABA ID"}
                defaultValue={details.waba_id}
                InputLabelProps={{ shrink: true }}
                value={wabaId}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
              />
            </Col>
          </Row>

          <Row>
            <Col md={6}>
              <DialogContentText>Name</DialogContentText>
              <TextField
                onChange={(e) => {
                  setWabaName(e.target.value);
                }}
                fullWidth
                defaultValue={details.name}
                placeholder={"Name"}
                InputLabelProps={{ shrink: true }}
                value={wabaName}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
              />
            </Col>
            <Col md={6}>
              <DialogContentText>Industry</DialogContentText>
              <Select
                placeholder={"Please select an industry..."}
                sx={{
                  "& legend": { display: "none" },
                  "& fieldset": { top: 0 },
                }}
                style={{ width: "100%" }}
                value={wabaIndustry ? wabaIndustry : "none"}
                onChange={(e) => setWabaIndustry(e.target.value)}
              >
                <MenuItem value="none" selected disabled>
                  Please select an industry...
                </MenuItem>
                {industryOptions.map((i) => {
                  return <MenuItem value={i}>{i}</MenuItem>;
                })}
              </Select>
              {/* <TextField
                            fullWidth
                            onChange={(e) => {
                                setWabaIndustry(e.target.value)
                            }}
                            placeholder={"Industry"}
                            defaultValue={details.industry}
                            inputLabelProps={{shrink: true}}
                            value={wabaIndustry}
                        /> */}
            </Col>
          </Row>
          <Row>
            <DialogContentText>Description</DialogContentText>
            <TextField
              id="outlined-multiline-static"
              multiline
              minRows={4}
              maxRows={8}
              fullWidth
              defaultValue={details.description}
              onChange={(e) => {
                setWabaDesc(e.target.value);
              }}
              placeholder={"Description"}
              inputLabelProps={{ shrink: true }}
              value={wabaDesc}
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
            />
          </Row>
          <Row>
            <DialogContentText>Website</DialogContentText>
            <TextField
              sx={{
                "& legend": { display: "none" },
                "& fieldset": { top: 0 },
              }}
              onChange={(e) => {
                setWabaWebsite(e.target.value);
              }}
              fullWidth
              defaultValue={details.website}
              placeholder={"Website"}
              inputLabelProps={{ shrink: true }}
              value={wabaWebsite}
            />
          </Row>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              handleClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={async () => {
              await onSubmit(details.waba_id);
              // handleClose()
            }}
          >
            Edit
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
